import { REGEX_PHONE } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import yup from 'src/libraries/validator.library';

export const PilotShape = {
  name: yup.string().required(),
  phone: yup.string().nullable(),
  Operators: yup.array().of(
    yup
      .object({
        operatorId: yup.number().required(),
        name: yup.string().required(),
        email: yup.string().nullable(),
        activeFlag: yup.boolean(),
        dispatchFlag: yup.boolean(),
      })
      .defined()
  ),
};

export const PilotSchema = yup
  .object()
  .shape({
    pilotId: yup.number(),
    ...PilotShape,
  })
  .defined();

export const PilotListSchema = yup
  .object({
    pilot: yup
      .object({
        count: yup.number(),
        rows: yup
          .array()
          .of(
            yup
              .object()
              .shape({
                pilotId: yup.number(),
                ...PilotShape,
              })
              .defined()
          )
          .defined(),
      })
      .defined(),
  })
  .defined();

export const PilotFormSchema = yup
  .object()
  .shape({
    pilotId: yup.number(),
    name: yup.string().required(),
    phone: yup
      .string()
      .matches(REGEX_PHONE, Lang.MSG_PHONE_NUMBER_ERROR)
      .required(),
  })
  .defined();

export const PilotResponsePayloadSchema = yup
  .object({
    pilot: yup
      .object({
        pilotId: yup.number(),
        name: yup.string(),
        phone: yup.string(),
      })
      .defined(),
  })
  .defined();

export type IPilot = yup.InferType<typeof PilotSchema>;
export type IPilotList = yup.InferType<typeof PilotListSchema>;
export type IPilotForm = yup.InferType<typeof PilotFormSchema>;
